import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const KompletteraAnlaggningsIdTest = lazy(() => import("@/pages/KompletteraAnlaggningsIdTest"));

export const Route = createFileRoute("/komplettera-anlaggningsid-test")({
  ssr: false,
  head: () => ({
    meta: [
      { title: "Testvy: komplettera anläggnings-ID | Elmarknad.se" },
      {
        name: "description",
        content:
          "Testvy av anläggnings-ID-kompletteringen – kräver ingen referens och sparar inget.",
      },
      { name: "robots", content: "noindex, nofollow" },
      { name: "googlebot", content: "noindex, nofollow" },
      { property: "og:title", content: "Testvy: komplettera anläggnings-ID | Elmarknad.se" },
      {
        property: "og:description",
        content: "Testvy av anläggnings-ID-kompletteringen hos Elmarknad.se.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: () => <KompletteraAnlaggningsIdTest />,
});
